import { useItem } from '@/composables/item'
import { documentContainerService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useDocumentContainerStore = defineStore(
	'documentContainer',
	() => {
		const { items, show, create, remove, attach, detach, getItem } =
			useItem<Api.DocumentContainer>(
				documentContainerService,
				'documentcontainers',
				'DocumentContainer',
				{
					hasModules: [
						{
							store: 'documents',
							name: 'document_files',
						},
					],
					options: { saveCreated: false },
				}
			)

		return {
			items,
			show,
			create,
			remove,
			attach,
			detach,
			getItem,
		}
	}
)

if (import.meta.hot) {
	import.meta.hot.accept(
		acceptHMRUpdate(useDocumentContainerStore, import.meta.hot)
	)
}
